// extracted by mini-css-extract-plugin
module.exports = {"ClickableRow":"SearchContacts_ClickableRow__16eWq"};